export default __webpack_public_path__ + "static/media/fileDetails.336f0877.png";